import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = () => {
    if (username === "farmacia@mutual22dic.com.ar" && password === "farma123") {
      localStorage.setItem("token", "fake_token"); // Guardamos el token en localStorage
      navigate("/home"); 
    } else {
      alert("Usuario o contraseña incorrectos");
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 400, mx: "auto", mt: 8 }}>
      <Typography variant="h5" textAlign="center" gutterBottom>
        VALIDACION DE AFILIADOS MUTUAL 22 DE DICIEMBRE
      </Typography>
      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="Usuario"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Contraseña"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button variant="contained" color="primary" onClick={handleLogin}>
          Iniciar Sesión
        </Button>
      </Box>
    </Paper>
  );
};

export default Login;
